import { render, staticRenderFns } from "./BookingDocuments.vue?vue&type=template&id=af0e698a&"
import script from "./BookingDocuments.vue?vue&type=script&lang=js&"
export * from "./BookingDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports